import ReviewEditionWithRef from './ReviewEdition';

export default ReviewEditionWithRef;
